import { render, staticRenderFns } from "./audit-log-toolbar.vue?vue&type=template&id=6b0b8ecd&"
import script from "./audit-log-toolbar.vue?vue&type=script&lang=js&"
export * from "./audit-log-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports